import {Accordion, AccordionDetails, AccordionSummary, Box, Grid, styled} from '@mui/material';
import {questions} from '../../../common/constants';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Color} from '../../../common/theme';

const WhiteBackgroundBox = styled(Box)({
    paddingTop: 84,
    paddingBottom: 40,
    paddingLeft: 32,
    paddingRight: 32,
    margin: 0,
    backgroundColor: Color.WHITE,
});

const FAQQuestion = (props: {question: string; answer: string; index: number}) => {
    const {question, answer, index} = props;
    return (
        <div>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}>
                    <span
                        style={{
                            color: Color.BLACK,
                            fontWeight: 400,
                            fontFamily: 'poppins',
                            fontSize: 16,
                        }}>
                        {question}
                    </span>
                </AccordionSummary>
                <AccordionDetails>
                    <span
                        style={{
                            fontSize: 12,
                            fontFamily: 'poppins',
                            fontWeight: 300,
                            color: Color.BLACK,
                        }}>
                        {answer}
                    </span>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export const FAQSection = () => {
    return (
        <WhiteBackgroundBox>
            <Grid container>
                <Grid item md={2} />
                <Grid item md={8}>
                    <span
                        style={{
                            fontSize: 32,
                            color: Color.SEA_GREEN,
                            fontWeight: 700,
                            fontFamily: 'Poppins',
                        }}>
                        <center>Frequently Answered Questions</center>
                    </span>
                </Grid>
            </Grid>
            <br />
            <br />
            {questions.map((item, index) => {
                return <FAQQuestion key={index} question={item.question} answer={item.answer} index={index} />;
            })}
            <br />
        </WhiteBackgroundBox>
    );
};
